import {useEffect, useState} from "react";
import useLatLng from "../uselatlng/uselatlng";

const useDistanceFromSites = (siteLat, siteLong) => {
    const [distanceDetails, setDistanceDetails] = useState(null)
    const islatlng = useLatLng();


    useEffect(() => {
        const message = {
            event_name: 'user_geo_distance_from_site',
            site_lat: siteLat,
            site_long: siteLong
        }
        const handleMessage = (event) => {
            const message = event.data;
            console.log("user_geo_distance_from_site fired response "+JSON.stringify(message))
            if (message?.curr_lat !== undefined || message?.curr_lat !== undefined || message?.distance_in_km !== undefined) {
                setDistanceDetails({
                    curr_lat: message?.curr_lat,
                    curr_long: message?.curr_long,
                    distance_in_km: message?.distance_in_km,
                    site_late: siteLat,
                    site_long: siteLong,
                    device_id: message?.device_id,
                    is_mock: message?.is_mock ?? 0,
                });
            }
        };

        if (window !== undefined && window.ReactNativeWebView !== undefined) {
            window.ReactNativeWebView.postMessage(JSON.stringify(message));
            window.addEventListener('message', handleMessage);
            console.log("user_geo_distance_from_site fired")
            return () => {
                window.removeEventListener('message', handleMessage);
            };
        }
    }, [siteLat, siteLong])

    useEffect(() => {
        if (distanceDetails === null && islatlng?.lat !== undefined && siteLat !== undefined) {
        
            console.log("custom distance")
            setDistanceDetails( {
                curr_lat: islatlng?.lat ?? null,
                curr_long: islatlng?.lng ?? null,
                distance_in_km: calcCrow(siteLat, siteLong, islatlng?.lat, islatlng?.lng),
                site_late: siteLat,
                site_long: siteLong,
                device_id: '',
                is_mock: 0,
            })
        }
    }, [islatlng, siteLong, siteLat])

    console.log("distanceDetails "+JSON.stringify(distanceDetails))
    return distanceDetails;
}

const toRad = (Value) => {
    return Value * Math.PI / 180
}

const calcCrow = (lat1, lon1, lat2, lon2) => {
    var R = 6371 // km
    var dLat = toRad(lat2 - lat1)
    var dLon = toRad(lon2 - lon1)
    var lat1 = toRad(lat1)
    var lat2 = toRad(lat2)

    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lat1) * Math.cos(lat2)
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
    var d = R * c
    return d
}
export default useDistanceFromSites;